import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import LandingPageWrapper from "../components/LandingPageWrapper";
import ROUTES from "../common/routes";

const NotFound = () => {
    const [translate] = useTranslation();
    const navigate = useNavigate();

    return (
        <LandingPageWrapper>
            <div className="d-flex flex-column text-center">
                <span className="display-6"><strong>404</strong></span>
                <span className="mt-2">{translate("OTM_PAGE_NOT_FOUND_MESSAGE")}</span>
                <div>
                    <Button
                        variant="primary"
                        className="mt-3"
                        onClick={() => navigate(ROUTES.LANDING)}
                    >
                        {translate("OTM_HOME_PAGE")}
                    </Button>
                </div>
            </div>
        </LandingPageWrapper>
    );
};

export default NotFound;
